"use client";

import React from "react";
import { createIcon } from "@chakra-ui/react";

const ScramblesIcon = createIcon({
  displayName: "ScramblesIcon",
  viewBox: "0 0 45 39.18",
  path: (
    <>
      <path
        d="M37.32,28.59l-2.91-2.91,3.18-3.18,6.75,6.75c.88.88.88,2.3,0,3.18l-6.75,6.75-3.18-3.18,2.91-2.91h-8.07c-.6,0-1.17-.24-1.59-.66L5.82,10.59H0v-4.5h6.75c.6,0,1.17.24,1.59.66l21.84,21.84h7.14ZM11.64,22.77l3.18,3.18-6.48,6.48c-.42.42-.99.66-1.59.66H0v-4.5h5.82l5.82-5.82ZM24.36,16.41l-3.18-3.18,6.48-6.48c.42-.42.99-.66,1.59-.66h8.07l-2.91-2.91,3.18-3.18,6.75,6.75c.88.88.88,2.3,0,3.18l-6.75,6.75-3.18-3.18,2.91-2.91h-7.14l-5.82,5.82Z"
        fill="currentColor"
      />
    </>
  ),
  defaultProps: {
    boxSize: "1em",
  },
});

export default ScramblesIcon;
